__turbopack_context__.v({
  "closeButton": "_4Vh-ya_closeButton",
  "footerText": "_4Vh-ya_footerText",
  "freeShippingText": "_4Vh-ya_freeShippingText",
  "headerContainer": "_4Vh-ya_headerContainer",
  "marketplaceFeesBenefitsList": "_4Vh-ya_marketplaceFeesBenefitsList",
  "modalContent": "_4Vh-ya_modalContent",
  "price": "_4Vh-ya_price",
  "row": "_4Vh-ya_row",
  "shippingBannerSpacing": "_4Vh-ya_shippingBannerSpacing",
  "totalPrice": "_4Vh-ya_totalPrice",
});
